import React from 'react'
import PopoverMenuContentItem from './popover-menu-content-item'

const PopoverMenuContent = ({ items = [] }) => {

    if (!items.length) return null

    return (
        <div className={`bimmatch-menu-popover-content ${(items.length > 1 ) ? "bimmatch-menu-popover-multi": "bimmatch-menu-popover-single"}`}>
            {items.map((item) => (
                <PopoverMenuContentItem key={item.id}  {...item} />
            ))}
        </div>
    )
}

export default PopoverMenuContent